import Vue from 'vue';
// 酒店(星级/钻级)枚举

    import ChannelConfig from '@/constants/channelConfig'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

let channelMap = {}

ChannelConfig.allChannelList.forEach(channel => {
  // const key = channel.competitor.toUpperCase()
  let achannel = JSON.parse(JSON.stringify(channel))
  channelMap[channel.upperName] = achannel
  channelMap[channel.upperName].value = channelMap[channel.upperName].CommentListPageConfig.channel + ''
  delete channelMap[channel.upperName].configValue
})

export const HOTEL_CEM_STAR_TYPE_ENUM = {
  STAR: {
    label: $t('cef78a'),
  },
  DIAMOND: {
    label: $t('e03faf'),
  },
}

// 不同渠道分数保留小位数 2025年6月5日 前端总结  但是目前确认后端已经做了控制
// 2 携程 9 Booking.com 11 Expedia 12 Hotels.com 14 Agoda 23 逸粉 保留2位
// 其他保留1位

// 点评渠道枚举
export const HOTEL_COMMENT_CHANNEL = channelMap

/**
 *0: '亲子出游',
  1: '代人预订',
  2: '商务出差',
  3: '团队出游',
  4: '夫妻/情侣',
  5: '家庭出游',
  6: '其他',
  7: '朋友出游',
  8: '爱宠人士',
  9: '独自出游'
 */
// 出游类型与点评渠道的映射关系
export const TRAVEL_TYPE_MAPPING = {
  0: {
    name: $t('62a033'),
    id: 1,
    en: 'Parent-child outings',
    channels: ['agoda', 'booking', 'ctrip', 'custom_wanda', 'elong', 'expedia', 'fliggy'],
  },
  1: { name: $t('ca0d44'), id: 9, en: 'Book for others', channels: ['ctrip', 'custom_wanda'] },
  2: {
    name: $t('c461b1'),
    id: 4,
    en: 'Business trip',
    channels: [
      'agoda',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'expedia',
      'fliggy',
      'hotel_com',
      'jinjiang',
      'qunar',
      'tripadvisor',
      'tripadvisor_en',
    ],
  },
  3: {
    name: $t('cc9980'),
    id: 8,
    en: 'Group trip',
    channels: ['agoda', 'booking', 'elong', 'expedia', 'jinjiang', 'tripadvisor'],
  },
  4: {
    name: $t('a89405'),
    id: 5,
    en: 'Couple / Lover',
    channels: [
      'agoda',
      'booking',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'expedia',
      'fliggy',
      'jinjiang',
      'qunar',
      'tripadvisor',
      'tripadvisor_en',
    ],
  },
  5: {
    name: $t('3918c8'),
    id: 3,
    en: 'Family trip',
    channels: ['agoda', 'ctrip', 'elong', 'expedia', 'hotel_com', 'jinjiang', 'tripadvisor', 'tripadvisor_en'],
  },
  6: {
    name: $t('97e49d'),
    id: 2,
    en: 'Others',
    channels: [
      'agoda',
      'booking',
      'ctrip',
      'custom_wanda',
      'delonix',
      'delonix_zh',
      'dianping',
      'douyin',
      'elong',
      'expedia',
      'fliggy',
      'google',
      'hotel_com',
      'jinjiang',
      'jinling',
      'kaiyuan',
      'meituan',
      'qunar',
      'rujia',
      'tripadvisor',
      'tripadvisor_en',
      'yaste',
      'yifei',
      'yifen',
    ],
  },
  7: {
    name: $t('37ada4'),
    id: 7,
    en: 'Friend trip',
    channels: [
      'agoda',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'fliggy',
      'hotel_com',
      'jinjiang',
      'tripadvisor_en',
    ],
  },
  8: { name: $t('28311b'), id: 10, en: 'Pet lovers', channels: ['expedia', 'fliggy'] },
  9: {
    name: $t('9228bc'),
    id: 6,
    en: 'Solo trip',
    channels: [
      'agoda',
      'booking',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'expedia',
      'fliggy',
      'jinjiang',
      'qunar',
      'tripadvisor',
      'tripadvisor_en',
    ],
  },
}

export const SHOW_TRAVEL_TYPE = [0, 1, 2, 3, 4, 5, 7, 8, 9]

export const getChannelByReserve = (reserveChannelIds = [], selectChannelIds = []) => {
  if (!reserveChannelIds.length) return []
  const channelMap = {}
  Object.values(HOTEL_COMMENT_CHANNEL).forEach(channel => {
    channelMap[channel.competitor] = channel.CommentListPageConfig
  })
  const channelNames = SHOW_TRAVEL_TYPE.map(type => {
    const { name, channels: allChannelSources, id, en } = TRAVEL_TYPE_MAPPING[type]
    const showChannels = allChannelSources.filter(channelName => {
      const channelObj = channelMap[channelName]
      return (
        channelObj &&
        reserveChannelIds.includes(channelObj.channel) &&
        (selectChannelIds.includes(channelName) || selectChannelIds.includes(channelObj.channel))
      )
    })
    return {
      tripPurpose: name,
      id: id,
      en: en,
      channelNames: showChannels.map(channelName => channelMap[channelName].name),
    }
  })

  return channelNames.filter(item => item.channelNames.length)
}

export const INDUSTRY_TYPE = [
  {
    industryType: 1,
    industryName: $t('8fddf4'),
  },
  {
    industryType: 2,
    industryName: $t('d3c589'),
  },
  {
    industryType: 3,
    industryName: $t('35c238'),
  },
]
